export default "__VITE_ASSET__D$094q5A__"